import WalletPayBreakDown from "./WalletPayBreakDown";

export default WalletPayBreakDown;